export const API_URL = 'https://admin.aicf.in/api/';
// export const API_URL = 'http://127.0.0.1:8000/api/';
export const RZ_KEY = 'rzp_live_WRK0rd8dW3aZ3g';
export const RZ_SECRET = 'sM4DVP4uYY05Hn1RXPBu6UxZ';
